export class ExportsSideBarMenu {
    menu = [
        {
            label: 'TP Exports',
            routerLink: '/exports/tp-exports',
        }
    ];
}